module.exports = __webpack_public_path__ + "img/buying-a-home-ico.573cd3e3.svg";